<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;">
      
      <a-form-item>
        <a-input v-model="name" allowClear @pressEnter="init_data" placeholder="部门">
          <a-icon slot="prefix" type="dropbox" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             style="background: #ffffff;" :loading="tableLoad" :rowKey="item=>item.id"
             bordered :pagination="false">

      <template slot="handle" slot-scope="text,recode">
        <a-button size="small" @click="clickEdit(recode)">编辑</a-button>
      </template>
      <!-- <template slot="footer" >
        <a-pagination
          v-model="page"
          style="text-align: right"
          show-size-changer
          :total="count"
          :page-size="page_size"
          @change="changePage"
          @showSizeChange="changePage"
        />
      </template> -->
    </a-table>

    <RelationEditDialog
          :show-dialog="editDialogShow"
          :dataInfo="dataInfo"
          :groupList="groupList"
          @close-dialog="closeEditDialog()"></RelationEditDialog>
  </div>
</template>

<script>
import {GetRelationList,GetGroupList} from "@/api/v1/group_api";
import RelationEditDialog from "@/components/V1/relationEditDialog";

export default {
  name: "Relation",
  components: {RelationEditDialog},
  data(){
    return {
      name:'',
      tableData:[],
      count:100,
      page:1,
      page_size:10,
      tableLoad:false,
      editDialogShow:false,
      groupList:[],
      dataInfo:[],
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '飞书部门', dataIndex: 'name',scopedSlots: { customRender: 'name' },},
        // {title: 'department_id', dataIndex: 'department_id',scopedSlots: { customRender: 'department_id' },},
        // {title: 'open_department_id', dataIndex: 'open_department_id',scopedSlots: { customRender: 'open_department_id' },},
        {title: '用户组', dataIndex: 'group_name',scopedSlots: { customRender: 'group_name' },},
        {title: '操作', dataIndex: 'handle',scopedSlots: { customRender: 'handle' }},
      ]
      return _table_columns
    }
  },
  methods: {
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetRelationList({
        name:this.name,
        page:this.page,
        page_size:this.page_size
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data
        }
      })
    },
    changePage(page,page_size){
      this.page = page
      this.page_size = page_size
      this.init_data()
    },
    closeEditDialog(){
      this.dataInfo = {}
      this.editDialogShow = false
      this.init_data()
    },
    clickEdit (record){
      GetGroupList({'parent':0}).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.groupList = resp.data
          this.dataInfo = record
          this.editDialogShow = true
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/System/User/Relation.vue